/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

type Props = {
  origenWareHouseAndDestinyWareHouse?: number;
  origenWareHouseAndDestinyForce?: number;
  origenForceAndDestinyForce?: number;
  origenForceAndDestinyWareHouse?: number;
};

const UseServiceShipment = (props: Props) => {
  const { showApiError } = useGlobalContext();
  const {
    catalog: catalogApi,
    inventory: inventoryApi,
    security: securityApi
  } = useApiContext();
  const { t } = useTranslation('global');

  // GET USER DETAILS
  const { data: dataUserActive } = useQuery(
    [KEYS.security.GetDetailsUser()],
    () => securityApi.accounts.GetDetailsUser(),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      onError: (error) => showApiError(error, t('errorMessages.user'), 3000),
      onSuccess: (data) => data,
      cacheTime: Infinity
    }
  );

  const { data: originWarehouses, isFetching: isFetchingOriginWarehouses } =
    useQuery(
      [KEYS.inventory.warehouse.GetOriginWarehouseByUser()],
      () => inventoryApi.warehouse.GetOriginWarehouseByUser(),
      {
        select: ({ data }) => data?.data,
        onError: (error) =>
          showApiError(error, t('errorMessages.warehouseList')),
        refetchOnWindowFocus: false
      }
    );

  const { data: orgintaskForce, isFetching: isFetchingOriginTaskForce } =
    useQuery(
      [KEYS.inventory.taskForce.GetOriginTaskForcesByUser()],
      () => inventoryApi.taskForce.GetOriginTaskForcesByUser(),
      {
        select: ({ data }) => data?.data,
        onError: (error) =>
          showApiError(error, t('errorMessages.engineersList')),
        refetchOnWindowFocus: false
      }
    );

  const { data: destinationForceIdById } = useQuery(
    [
      KEYS.inventory.warehouse.GetDestinyTaskForcesById(
        props?.origenForceAndDestinyForce
      )
    ],
    () =>
      inventoryApi.warehouse.GetDestinyTaskForcesById(
        props?.origenForceAndDestinyForce
      ),
    {
      select: (data) => data?.data?.data,
      onError: (error) =>
        showApiError(error, t('errorMessages.engineersList'), 3000),
      enabled: !!props?.origenForceAndDestinyForce,
      onSuccess: (data) => data,
      refetchOnWindowFocus: false
    }
  );

  const {
    data: destinationEngennierById,
    isLoading: isLoadingDestinationEngineersById
  } = useQuery(
    [
      KEYS.inventory.warehouse.GetDestinationEnginnersById(
        props?.origenForceAndDestinyWareHouse
      )
    ],
    () =>
      inventoryApi.warehouse.GetDestinationEnginnersById(
        props?.origenForceAndDestinyWareHouse
      ),
    {
      select: (data) => data?.data?.data,
      onError: (error) =>
        showApiError(error, t('errorMessages.engineersList'), 3000),
      enabled: !!props?.origenForceAndDestinyWareHouse,
      onSuccess: (data) => data,
      refetchOnWindowFocus: false
    }
  );

  const { data: destinationWareHouseById } = useQuery(
    [
      KEYS.inventory.warehouse.GetDestinyWarehousesById(
        props?.origenWareHouseAndDestinyForce
      )
    ],
    () =>
      inventoryApi.warehouse.GetDestinyWarehousesById(
        props?.origenWareHouseAndDestinyForce
      ),
    {
      select: (data) => data?.data?.data,
      onError: (error) =>
        showApiError(error, t('errorMessages.warehouseList'), 3000),
      enabled: !!props?.origenWareHouseAndDestinyForce,
      onSuccess: (data) => data,
      refetchOnWindowFocus: false
    }
  );

  const {
    data: destinationWarehousesById,
    isLoading: isLoadingDestinationWarehousesById
  } = useQuery(
    [
      KEYS.inventory.warehouse.GetDestinationWarehousesById(
        props?.origenWareHouseAndDestinyWareHouse
      )
    ],
    () =>
      inventoryApi.warehouse.GetDestinationWarehousesById(
        props?.origenWareHouseAndDestinyWareHouse
      ),
    {
      select: (data) => data?.data?.data,
      onError: (error) =>
        showApiError(error, t('errorMessages.warehouseList'), 3000),
      enabled: !!props?.origenWareHouseAndDestinyWareHouse,
      onSuccess: (data) => data,
      refetchOnWindowFocus: false
    }
  );

  const { data: currencyOptions } = useQuery(
    [KEYS.catalog.currencies.list()],
    () => catalogApi.currencies.list(),
    {
      select: (data) =>
        data.data.data as {
          id: number;
          name: string;
        }[],
      onError: (error) => showApiError(error, t('errorMessages.currencies')),
      refetchOnWindowFocus: false
    }
  );

  const { data: couriersOptions } = useQuery(
    [KEYS.catalog.inventory.getCouriers()],
    () => catalogApi.inventory.getCouriers(),
    {
      select: (data) => data?.data?.data,
      onError: (error) => showApiError(error, t('errorMessages.currencies')),
      refetchOnWindowFocus: false
    }
  );

  const { data: shipmentPriorityOptions } = useQuery(
    [KEYS.catalog.inventory.getShipmentPriority()],
    () => catalogApi.inventory.getShipmentPriority(),
    {
      select: (data) => data?.data?.data,
      onError: (error) => showApiError(error, t('errorMessages.currencies')),
      refetchOnWindowFocus: false
    }
  );

  return {
    destinationForceIdById,
    destinationWareHouseById,
    originWarehouses,
    isFetchingOriginWarehouses,
    orgintaskForce,
    isFetchingOriginTaskForce,
    destinationEngennierById,
    destinationWarehousesById,
    currencyOptions,
    couriersOptions,
    shipmentPriorityOptions,
    isLoadingDestinationEngineersById,
    isLoadingDestinationWarehousesById,
    dataUserActive
  };
};

export default UseServiceShipment;
